<template>
  <div>
    <BreadCrumbTemplate :bread-crumb-list="breadCrumbList" />
  </div>
</template>

<script>
import BreadCrumbTemplate from '@/components/Shared/BreadCrumb/BreadCrumbTemplate'

export default {
  name: 'AdminBreadCrumb',
  components: { BreadCrumbTemplate },
  props: {
    title: { type: String, required: true },
    list: { type: Array, required: false },
  },
  computed: {
    listHead() {
      return [{ title: 'ホーム', path: '/' }]
    },
    breadCrumbList() {
      const list = this.list || []
      return [...this.listHead, ...list, { title: this.title, path: null }]
    },
  },
}
</script>
